var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1798_14780)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 21C1.25 20.5858 1.58579 20.25 2 20.25H22C22.4142 20.25 22.75 20.5858 22.75 21C22.75 21.4142 22.4142 21.75 22 21.75H2C1.58579 21.75 1.25 21.4142 1.25 21Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13.75C4.86193 13.75 4.75 13.8619 4.75 14V20C4.75 20.1381 4.86193 20.25 5 20.25H7C7.13807 20.25 7.25 20.1381 7.25 20V14C7.25 13.8619 7.13807 13.75 7 13.75H5ZM3.25 14C3.25 13.0335 4.0335 12.25 5 12.25H7C7.9665 12.25 8.75 13.0335 8.75 14V20C8.75 20.9665 7.9665 21.75 7 21.75H5C4.0335 21.75 3.25 20.9665 3.25 20V14Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 17C5.25 16.5858 5.58579 16.25 6 16.25H6.5C6.91421 16.25 7.25 16.5858 7.25 17C7.25 17.4142 6.91421 17.75 6.5 17.75H6C5.58579 17.75 5.25 17.4142 5.25 17Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.75C8.86193 2.75 8.75 2.86193 8.75 3V20C8.75 20.1381 8.86193 20.25 9 20.25H19C19.1381 20.25 19.25 20.1381 19.25 20V3C19.25 2.86193 19.1381 2.75 19 2.75H9ZM7.25 3C7.25 2.0335 8.0335 1.25 9 1.25H19C19.9665 1.25 20.75 2.0335 20.75 3V20C20.75 20.9665 19.9665 21.75 19 21.75H9C8.0335 21.75 7.25 20.9665 7.25 20V3Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5H11V7H13V5Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5H15V7H17V5Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.5H11V10.5H13V8.5Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5H15V10.5H17V8.5Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12H15V14H17V12Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5H15V17.5H17V15.5Z",
    fill: "#676767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1798_14780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.706bae04beb9e2fa70957a7aa2cc5bf2.svg";
export { ForwardRef as ReactComponent };